// ⚠️ Ce template est spreadé tel quel dans les documents `animals` écrits en
// prod (cf. _importAnimalFromZims). Ne JAMAIS y mettre de valeurs factices :
// un champ absent vaut mieux qu'une valeur inventée (id d'espèce inexistant,
// date de naissance fictive, enclos d'un autre zoo…).
export const ANIMAL_TEMPLATE = {
    animalBelongToEnclosure: false,
    animalBelongToGroup: false,
    animalChipId: null,
    animalGroupData: null,
    animalGroupId: null,
    animalLocalId: null,
    animalProfilePicture: false,
    label: "",
    specieLatinName: "",
    specieName: "",
}
